module.exports = __webpack_public_path__ + "static/media/fuel2.33fb2fe2.svg";